import React, { Component } from 'react';
import classnams from 'classnames';
import PropTypes from 'prop-types';
import styles from './myreawrd.module.less';
import img from '../images/rewardInfo.png';
import { getMarketingIncentivesByOpenId } from '../../../service/chat-service';
import tools from '../../../utils/tools';

const propTypes = {
  history: PropTypes.arrayOf(PropTypes.string),
};
const defaultProps = {
  history: [],
};

class Forwardeward extends Component {
  constructor(props) {
    super(props);

    this.state = {
      forwardList: [],
      // progressWid: '',
    };
  }

  componentDidMount() {
    window.document.title = '参与转发';
    this.loadMapList();
  }

  jumpPage = (item) => {
    const { history } = this.props;
    const url = item.sourceUrl.split('&');
    const sourceUrl = url.filter((item1) => {
      if (item1.indexOf('timeStamp') === -1) {
        return item1;
      }
      return null;
    });
    history.push(
      `/rewardRule?productId=${item.product_id}&sourceUrl=${sourceUrl.join('&')}&productName=null&marketingId=${
        item.marketing_id
      }`,
    );
  }

  loadMapList = async () => {
    const snsapiBaseOpenId = localStorage.getItem('snsapiBaseOpenId');

    const { code, data } = await getMarketingIncentivesByOpenId(snsapiBaseOpenId);
    if (code === 10000) this.setState({ forwardList: data });
  }

  renderTaskList = () => {
    const { forwardList } = this.state;
    const { pageList } = forwardList;
    if (JSON.stringify(pageList) !== '[]' && pageList) {
      return pageList.map((item) => (
        <div key={item.name} className={styles.forwardBox} style={{ paddingBottom: '0' }}>
          <div className={classnams(styles.redList, styles.redListBorder)}>
            <img src={item.img2} alt="headImg" />
            <div style={{ marginLeft: '50px' }}>
              <div className={styles.redItem}>
                <i>·</i>
                「
                {item.name}
                」
              </div>
              <div className={styles.redDateInfo}>
                <div style={{ color: '#cbcbcb', fontSize: '13px' }}>
                  截止时间：
                  {tools.formatUnixtimestamp(item.endDate)}
                </div>
                <div style={{ color: '#FF6516', fontSize: '13px' }}>
                  已集齐红包
                  {item.userBalance / 100}
                  元
                </div>
              </div>
            </div>
            <div className={styles.progressInner}>
              <div
                className={styles.progressBg}
                style={{ width: `${(item.userBalance / item.lastAmount) * 100}%` }}
              />
              <span className={styles.progressNum}>{`${item.userBalance / 100} / ${item.lastAmount / 100} 元`}</span>
            </div>
          </div>
          <div className={styles.progressBtn} onClick={this.jumpPage.bind(this, item)} role="button" tabIndex={0}>
            继续转发
          </div>
        </div>
      ));
    }
    return true;
  }

  render() {
    return (
      <div className={styles.containerBox} style={{ paddingTop: '0' }}>
        {this.renderTaskList()}
      </div>
    );
  }
}

Forwardeward.propTypes = propTypes;
Forwardeward.defaultProps = defaultProps;

export default Forwardeward;
